var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "4D36904D-75A6-46DF-8A5D-43A5A9A4FA00")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.99897282,10.4225636 C7.78531992,10.4225636 7.57166702,10.3354589 7.42375348,10.1817932 L3.44652258,6.20291887 C3.11782581,5.88161778 3.11782581,5.36145516 3.44652258,5.04097581 C3.76700193,4.71967473 4.28469934,4.71967473 4.60517869,5.04097581 L7.99897282,8.43805685 L11.4009844,5.04097581 C11.7214637,4.71967473 12.2391611,4.71967473 12.5596405,5.04097581 C12.8801198,5.36145516 12.8801198,5.88161778 12.5596405,6.20291887 L8.58240959,10.1817932 C8.42627862,10.3354589 8.22084314,10.4225636 7.99897282,10.4225636",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fitness-Style",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fitness-Style---Dashboard---Account---Reimbursement-History",
    transform: "translate(-389.000000, -615.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(190.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(29.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Action/ic_action_Arrow-Input",
    transform: "translate(167.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_action_Arrow-Input",
    fill: "#9B9B9B",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))))));
}
export default __webpack_public_path__ + "static/media/ic-action-arrow-down.529968fb.svg";
export { SvgIcActionArrowDown as ReactComponent };